import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }: DeleteConfirmationModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent maxW="500px">
                <ModalHeader color="#9FB50C">Conferma Eliminazione</ModalHeader>
                <ModalCloseButton _focus={{ boxShadow: 'none' }} zIndex={10} />
                <ModalBody>
                    Sei sicuro di voler eliminare questo modello?
                </ModalBody>
                <ModalFooter>
                    <Flex w="100%" gap={2} flexWrap="wrap" justify="center">
                        <Button
                            colorScheme="red"
                            flex="1"
                            minW="50px"
                            onClick={onConfirm}
                        >
                            Elimina
                        </Button>
                        <Button
                            colorScheme="gray"
                            flex="1"
                            minW="50px"
                            onClick={onClose}
                        >
                            Annulla
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteConfirmationModal;